export default "__VITE_ASSET__385c57df__"